/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimeTuteurService = {
    async pushData(request: any, captchaToken: string) {
        //request.dataAreCorrect = request.dataAreCorrect === 'on';

        if (request.bankAttestationFile) {
            request.bankAttestationFileName =
                'BankAttestation' +
                getFileExtension(request.bankAttestationFile);

            request.bankAttestationFile = await getFilePromise(
                request.bankAttestationFile
            );
        }

        request.nationalRegisterTutor = request.nationalRegisterTutor.replace(
            /\.|-/g,
            ''
        );
        request.nationalRegisterTrainee =
            request.nationalRegisterTrainee.replace(/\.|-/g, '');
        request.numberCompany = request.numberCompany.replace(/\./g, '');

        request.schoolAttestationFileName =
            'SchoolAttestation' +
            getFileExtension(request.schoolAttestationFile);

        request.addressCompany =
            request.addressStreet +
            ' ' +
            request.addressNumber +
            ', ' +
            request.addressPostal +
            ' ' +
            request.addressLocality;

        request.schoolAttestationFile = await getFilePromise(
            request.schoolAttestationFile
        );

        request.captchaToken = captchaToken;

        return await fetch('/api/FondsRebond/PushTuteur', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
        });
    },
};

function getFileExtension(item: File): string {
    return '.' + item.name.split('.').pop();
}

function getFilePromise(file: any): Promise<any> {
    const filePromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as any);
    });

    return filePromise;
}
